import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, InputNumber } from 'antd';

const CertificateAmountModal = ({ visible, onOk, onCancel, loading }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onOk(values.amount);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title="Enter Certificate Amount"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="amount"
          label="Certificate Amount"
          rules={[
            { required: true, message: 'Please enter the certificate amount' },
            { type: 'number', message: 'Please enter a valid number' }
          ]}
        >
          <InputNumber
            style={{ width: '100%' }}
            precision={2}
            placeholder="Enter amount"
            prefix="£"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

CertificateAmountModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default CertificateAmountModal;
